import {
    DocumentData,
    FirestoreDataConverter,
    QueryDocumentSnapshot,
    SnapshotOptions,
} from 'firebase/firestore';
import { OfferProduct, Order, Patient, UserOffer } from '../../Models';

export const orderConverter: FirestoreDataConverter<Order> = {
    toFirestore(): DocumentData {
        return {};
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Order {
        const data = snapshot.data(options)!;
        return {
            id: snapshot.id,
            customer_id: data.customer_id,
            short_id: data.short_id,
            state: data.state,
            health_provider: data.health_provider,
            creation_timestamp: data.creation_timestamp.toDate(),
            viewable_by: data.viewable_by || [],
            viewable_timeline: (data.viewable_timeline || []).map((x: any) => ({
                ...x,
                viewable_at: x.viewable_at?.toDate(),
            })),
            assigned_pharmacy_id: data.assigned_pharmacy_id,
            hp_authentication: data.hp_authentication
                ? {
                      ...data.hp_authentication,
                      last_request_timestamp:
                          data.hp_authentication?.last_request_timestamp?.toDate(),
                      last_sent_timestamp: data.hp_authentication?.last_sent_timestamp?.toDate(),
                      last_error_timestamp: data.hp_authentication?.last_error_timestamp?.toDate(),
                  }
                : undefined,
            trip_type: data.trip_type,
            delivery_id: data.delivery_id,
            patient: data.patient, // todo esto creo no está bien,
            feedback: data.feedback,
            rejections: (data.rejections || []).map((rejection: any) => ({
                ...rejection,
                creation_timestamp: rejection.creation_timestamp?.toDate(),
            })),
        };
    },
};

export const userOfferConverter: FirestoreDataConverter<UserOffer> = {
    toFirestore(): DocumentData {
        return {};
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): UserOffer {
        const data = snapshot.data(options)!;
        const result: UserOffer = {
            id: snapshot.id,
            order_id: snapshot.ref.parent.parent!.id,
            pharmacy_id: data.pharmacy_id,
            state: data.state,
            scheduled_stock_datetime: data.scheduled_stock_datetime?.toDate(),
        };
        if (data.prescription_charged_price) {
            result.prescription_charged_price = data.prescription_charged_price / 100; // del server vienen en centavos
        }
        if (data.prescription_products?.length > 0 || data.products?.length > 0) {
            // todo pasar todo a data.products
            result.products = (data.prescription_products || data.products).map(
                (product: OfferProduct) => ({
                    id: product.id,
                    name: product.name,
                    generic_name: product.generic_name,
                    quantity: product.quantity,
                    unit_price: product.unit_price / 100, // del server vienen en centavos
                    discount_percent: product.discount_percent,
                }),
            );
        }
        return result;
    },
};

export const patientConverter: FirestoreDataConverter<Patient> = {
    toFirestore(): DocumentData {
        return {};
    },
    fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Patient {
        const data = snapshot.data(options)!;
        return {
            fullname: data.fullname,
            national_id: data.national_id,
            phone_number: data.phone_number,
            address: data.address,
            referrer_pharmacy_ids: data.referrer_pharmacy_ids,
        };
    },
};
